import React from 'react';
import { Utensils, Plus, Wine, PenLine } from 'lucide-react';

/**
 * FloatingActionButtons - FABs for adding meals, snacks, drinks
 */
const FloatingActionButtons = ({
  onAddMeal,
  onAddSnack,
  onAddDrink,
  onTextEntry,
}) => {
  return (
    <div className="fixed bottom-8 right-8 flex flex-col gap-3 z-30">
      {/* Photo upload buttons */}
      <button
        data-testid="fab-add-meal-button"
        className="w-16 h-16 rounded-full bg-primary text-primary-foreground shadow-2xl flex items-center justify-center hover:scale-110 active:scale-95 transition-all"
        onClick={onAddMeal}
        title="Add Meal (Photo)"
      >
        <Utensils className="w-7 h-7" />
      </button>
      <button
        data-testid="fab-add-snack-button"
        className="w-14 h-14 rounded-full bg-secondary text-secondary-foreground shadow-xl flex items-center justify-center hover:scale-110 active:scale-95 transition-all"
        onClick={onAddSnack}
        title="Add Snack (Photo)"
      >
        <Plus className="w-6 h-6" />
      </button>
      <button
        data-testid="fab-add-drink-button"
        className="w-14 h-14 rounded-full bg-card border-2 border-primary text-primary shadow-xl flex items-center justify-center hover:scale-110 active:scale-95 transition-all"
        onClick={onAddDrink}
        title="Add Drink (Photo)"
      >
        <Wine className="w-6 h-6" />
      </button>
      {/* Text entry button */}
      <button
        data-testid="fab-text-entry-button"
        className="w-14 h-14 rounded-full bg-amber-500 text-white shadow-xl flex items-center justify-center hover:scale-110 active:scale-95 transition-all"
        onClick={onTextEntry}
        title="Describe Meal/Drink (No Photo)"
      >
        <PenLine className="w-6 h-6" />
      </button>
    </div>
  );
};

export default FloatingActionButtons;
